import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { OptionsSource } from '../../../../core/core.models';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { DistributionCalendar } from '../distribution-calendars.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { MeansOfDeliveryService } from '../../means-of-delivery/means-of-delivery.service';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { MeanOfDelivery } from '../../means-of-delivery/means-of-delivery.models';
import { DeliveryZonesService } from '../../delivery-zones/delivery-zones.services';
import { DeliveryZone } from '../../delivery-zones/delivery-zones.models';

@Component({
  selector: 'app-distribution-calendars-form',
  templateUrl: './distribution-calendars-form.component.html',
  styleUrls: ['./distribution-calendars-form.component.scss']
})
export class DistributionCalendarsFormComponent extends BaseFormComponent implements OnInit {
  public pointsOfSale: OptionsSource;
  public meansOfDelivery: OptionsSource;
  public deliveryZones: OptionsSource;

  constructor(
    private deliveryZonesService: DeliveryZonesService,
    private pointsOfSaleService: PointsOfSaleService,
    private meansOfDeliveryService: MeansOfDeliveryService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/distribution-calendars`;
    this.prepareLookupData();
    this.prepareFormData(new DistributionCalendar(), (response: DistributionCalendar) => {
      return this.modifyResponse(response);
    });
  }

  public modifyResponse(response: DistributionCalendar) {
    response.breadcrumbsId = `${this.utilityService.formatDate(response.date)}, ${this.utilityService.formatTime(response.timeFrom.toString())} - ${this.utilityService.formatTime(response.timeTo.toString())}`;

    if (response.pointOfSale) {
      let pointOfSale = <PointOfSale>response.pointOfSale;
      response.pointOfSale = pointOfSale.id;
    }

    if (response.meansOfDelivery) {
      let meansOfDelivery = <MeanOfDelivery>response.meansOfDelivery;
      response.meansOfDelivery = meansOfDelivery.id;
    }

    if (response.deliveryZone) {
      let deliveryZone = <DeliveryZone>response.deliveryZone;
      response.deliveryZone = deliveryZone.id;
    }

    this.active = response.active;
    this.activeText = response.active ? 'SHARED.DEACTIVATE' : 'SHARED.ACTIVATE';

    return response;
  }

  prepareLookupData() {
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.meansOfDelivery = this.meansOfDeliveryService.getMeansOfDeliveryOptions();
    this.deliveryZones = this.deliveryZonesService.getDeliveryZonesOptions();
  }
}
